import { useQuery } from 'react-query';
import { type ChatRoomDetailResponse, getChatRoomDetail } from '../../services/chatService';

export function useGetChatRoomDetail(chatRoomId: string) {
  return useQuery<ChatRoomDetailResponse, Error>({
    queryKey: ['chatRoom', chatRoomId],
    queryFn: () => getChatRoomDetail(chatRoomId),
    enabled: !!chatRoomId
  });
}
